module.exports = __webpack_public_path__ + "img/footerright.fde18e33.png";